import styled from 'styled-components';

export const ButtonGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: center;
  padding-right: 38px;
`;

export const Button = styled.input`
  cursor: pointer;
  width: 15px;
  height: 15px;
  display: ${props => props.isCustom && 'none;'};
`;

export const Label = styled.label`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  font-size: 15px;
  line-height: ${props => (props.isCustom ? 'unset' : '16px')};
  cursor: pointer;
`;

export const Text = styled.span`
  padding-top: 3px;
  padding-left: 3px;
`;
